import React, { Component } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import {reports} from "../../../components/Report.js";
export default class Billings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_start_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
      filter_warehouse_id: "",
      filter_company_id: "",
      filter_status: "",

      data: [],
      count: 10,
      data_product: [],
      data_user: [],
      data_warehouse: [],
      data_category: [],
      data_company: [],

      data_check: [],

      tab: "check-list",

      id: "",
      uid: "",
      return_code: "",

      // สินค้า
      type: "",
      name: "",
      date: "",
      start_date: "",
      end_date: "",
      count_item: "",
      ref_number: "",
      activity_type: "",
      customer_id: "",
      supplier_id: "",
      warehouse_id: "",
      user_id: "",
      amount: "",
      discount: "",
      vat: "",
      amount_net: "",
      cause: "",
      status: "",
      remark: "",
      transaction_list: [],

      category_id: "",

      detail: null,
    };
    this.tableRef = React.createRef();
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_company_id,
      filter_status,
    } = this.state;
    let data, count, data_user, data_warehouse, data_category, data_company;
    loading(true);
    let [
      result,
      result_user,
      result_warehouse,
      result_category,
      result_company,
    ] = await Promise.all([
      GET("admin/stock-activities/list", {
        page: 0,
        page_size: 10000,
        data_search: filter_search,
        start_date: filter_start_date,
        end_date: filter_end_date || filter_start_date,
        warehouse_id: filter_warehouse_id,
        supplier_id: filter_company_id,
        status_code: filter_status,
        type: "รับสินค้า",
      }),
      GET("admin/setting/users/list", { page: 0, data_search: "" }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      GET("admin/setting/categories/list", { page: 0, data_search: "" }),
      GET("admin/setting/companies/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
      let result_product = await Promise.all(
        data.map((e) => GET("admin/stock-activities/list", { uid: e.uid }))
      );
      let array = [];
      for (let item of result_product) {
        array.push({
          ...item.data,
        });
      }

      data = array;
    }
    if (result_user?.status) {
      data_user = result_user.data.map((e) => ({
        value: e.uid,
        label: e.full_name,
      }));
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    if (result_category?.status) {
      data_category = result_category.data.map((e) => ({
        value: e.uid,
        label: `${e.category_code} ${e.name}`,
        id: e.id,
        warehouse_id: e.warehouse.uid,
      }));
    }
    if (result_company?.status) {
      data_company = result_company.data.map((e) => ({
        value: e.uid,
        label: e.company_name,
        warehouse_id: e.warehouse?.uid,
      }));
    }
    this.setState({
      data,
      count,
      data_user,
      data_warehouse,
      data_category,
      data_company,
    });
    loading(false);
  };
getTableArrayWithSpan = () => {
  const table = this.tableRef.current;
  if (!table) return [];

  const rows = Array.from(table.querySelectorAll("tbody tr"));
  const matrix = [];
  const spanMap = {}; // เก็บตำแหน่งที่ถูกจองจาก rowspan

  rows.forEach((tr, rowIndex) => {
    matrix[rowIndex] = matrix[rowIndex] || [];
    let colIndex = 0;

    // ข้ามช่องที่ถูก rowspan จากแถวก่อน (ใส่ค่าว่าง)
    while (spanMap[`${rowIndex},${colIndex}`]) {
      matrix[rowIndex][colIndex] = "";
      delete spanMap[`${rowIndex},${colIndex}`];
      colIndex++;
    }

    Array.from(tr.children).forEach((cell) => {
      const text = cell.innerText.trim();
      const colspan = Number(cell.getAttribute("colspan") || 1);
      const rowspan = Number(cell.getAttribute("rowspan") || 1);

      for (let r = 0; r < rowspan; r++) {
        for (let c = 0; c < colspan; c++) {
          const targetRow = rowIndex + r;
          const targetCol = colIndex + c;

          matrix[targetRow] = matrix[targetRow] || [];

          // ตำแหน่งจริง ใส่ text / ที่เหลือใส่ ""
          matrix[targetRow][targetCol] =
            r === 0 && c === 0 ? text : "*";

          // ถ้า rowspan > 1 จองช่องแถวถัดไป
          if (r > 0) {
            spanMap[`${targetRow},${targetCol}`] = true;
          }
        }
      }

      colIndex += colspan;

      // ข้ามช่องที่ถูกจองไว้
      while (spanMap[`${rowIndex},${colIndex}`]) {
        matrix[rowIndex][colIndex] = "";
        delete spanMap[`${rowIndex},${colIndex}`];
        colIndex++;
      }
    });
  });

  return matrix;
} 
colSpan = (item, index) => {
  // ช่องนี้เป็นตัวที่โดน merge อยู่แล้ว
  if (item[index] === "*") return 0;

  let span = 1;

  for (let i = index + 1; i < item.length; i++) {
    if (item[i] === "*") {
      span++;
    } else {
      break;
    }
  }

  return span || "";
};
      ExportPDF = async () => {
        const data_list = this.getTableArrayWithSpan();

      const obj = {
            table: {
              headerRows: 0,
              widths: ["auto",100,"auto","auto","auto","auto","auto","auto"],
              body: [
                [
              { text: " ", alignment: "center", border: [0, 0, 0, 1], colSpan:8, fontSize: 1 },
              "",
              "",
              "",
              "",
              "",
              "",
              ""
            ],
                ...data_list.map((item, index) => {
                  let border = [1, 0, 1, 0];let color = "#ffffff";
                  if(index === data_list.length - 1){
                    border = [1, 0, 1, 1];
                  }
                  if(item[0]){
                    border = !item[0].includes("ลำดับ") ? [0, 0, 0, 0]: [1, 1, 1, 1];
                    color = data_list[index + 1]?.includes("ลำดับ") ? "#d8d8d8": "#ffffff";
                    return [
                        item[0] === "*" ? "" : { text: item[0], alignment: "center", colSpan: this.colSpan(item, 0), fillColor: color, border: [1, border[1], border[2], border[3]] },
                        item[1] === "*" ? "" : { text: item[1], alignment: "left", colSpan: this.colSpan(item, 1), fillColor: color, border },
                        item[2] === "*" ? "" : { text: item[2], alignment: "center", colSpan: this.colSpan(item, 2), fillColor: color, border },
                        item[3] === "*" ? "" : { text: item[3], alignment: "center", colSpan: this.colSpan(item, 3), fillColor: color, border },
                        item[4] === "*" ? "" : { text: item[4], alignment: "right", colSpan: this.colSpan(item, 4), fillColor: color, border },
                        item[5] === "*" ? "" : { text: item[5], alignment: "right", colSpan: this.colSpan(item, 5), fillColor: color, border },
                        item[6] === "*" ? "" : { text: item[6], alignment: "right", colSpan: this.colSpan(item, 6), fillColor: color, border: [border[0], border[1], item[0].includes("วันที่รับเข้า") ? 1 : border[2], border[3]] },
                        item[7] === "*" ? "" : { text: item[7], alignment: "right", colSpan: this.colSpan(item, 7), fillColor: color, border: [border[0], border[1], 1, border[3]] },
                      ]
                  }
                  else{
                     border = [1, 1, 1, 1];
                      return [
                        { text: item[0], alignment: item[3] === "รวมเป็นเงิน" ? "center":"right", border, fillColor: item[2] === "รวมเป็นเงิน" ? "#f1f1f1" : "#ffffff" },
                        { text: item[1], alignment: item[2] === "รวมเป็นเงิน" ? "center":"right", border, fillColor: item[2] === "รวมเป็นเงิน" ? "#f1f1f1" : "#ffffff" },
                        { text: item[2], alignment: item[2] === "รวมเป็นเงิน" ? "center":"right", border, fillColor: item[2] === "รวมเป็นเงิน" ? "#f1f1f1" : "#ffffff" },
                        { text: item[3], alignment: item[2] === "รวมเป็นเงิน" ? "center":"right", border, fillColor: item[2] === "รวมเป็นเงิน" ? "#f1f1f1" : "#ffffff" },
                        { text: item[4], alignment: item[2] === "รวมเป็นเงิน" ? "center":"right", border, fillColor: item[2] === "รวมเป็นเงิน" ? "#f1f1f1" : "#ffffff" },
                        { text: item[5], alignment: item[2] === "รวมเป็นเงิน" ? "center":"right", border, fillColor: item[2] === "รวมเป็นเงิน" ? "#f1f1f1" : "#ffffff" },
                        { text: item[6], alignment: item[2] === "รวมเป็นเงิน" ? "center":"right", border, fillColor: item[2] === "รวมเป็นเงิน" ? "#f1f1f1" : "#ffffff" },
                        { text: item[7], alignment: item[2] === "รวมเป็นเงิน" ? "center":"right", border, fillColor: item[2] === "รวมเป็นเงิน" ? "#f1f1f1" : "#ffffff" },
                      ]}
                  }
              ),
              ],
            },
          };
      reports("รายงานรับสินค้า", obj, 14, "portrait");
    }
  render() {
    const {
      modal_detail,
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_company_id,
      filter_status,
      data,
      count,
      data_warehouse,
      data_company,
      id,
      uid,
      bank_name,
      account_number,
      account_name,
      detail,
    } = this.state;
    const startTime = new Date(
      format_date(filter_start_date, "yyyy-MM-ddT00:00:00.000Z", "en")
    ).getTime();
    const endTime = new Date(
      format_date(filter_end_date || filter_start_date, "yyyy-MM-ddT23:59:59.999Z", "en")
    ).getTime();
    const data_filtered =
      data?.filter((item) => {
        const matchSearch =
          !filter_search ||
          JSON.stringify(
            item?.transaction_list.map((e) => e.product_code + e.product_name)
          ).includes(filter_search);
        if (!matchSearch) return false;

        const receiveTime = new Date(item.date).getTime();
        return !isNaN(receiveTime) && receiveTime >= startTime && receiveTime <= endTime;
      }) || [];
    const grand_total = data_filtered.reduce(
      (sum, item) => ({
        amount: sum.amount + Number(item?.amount || 0),
        discount: sum.discount + Number(item?.discount || 0),
        amount_after_discount:
          sum.amount_after_discount +
          (Number(item?.amount || 0) - Number(item?.discount || 0)),
        vat: sum.vat + Number(item?.vat || 0),
        delivery_cost: sum.delivery_cost + Number(item?.delivery_cost || 0),
        amount_net: sum.amount_net + Number(item?.amount_net || 0),
      }),
      {
        amount: 0,
        discount: 0,
        amount_after_discount: 0,
        vat: 0,
        delivery_cost: 0,
        amount_net: 0,
      }
    );
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายการรับสินค้า</h4>
            </div>
            <div className="d-flex flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา เลขที่เอกสาร, บริษัท..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="คลังสินค้า..."
                  options={data_warehouse}
                  onChange={(e) => {
                    this.setState({ filter_warehouse_id: e });
                  }}
                  value={filter_warehouse_id}
                />
              </div>
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="บริษัทจำหน่าย..."
                  options={data_company.filter(
                    (e) =>
                      !filter_warehouse_id ||
                      e.warehouse_id === filter_warehouse_id
                  )}
                  onChange={(e) => {
                    this.setState({ filter_company_id: e });
                  }}
                  value={filter_company_id}
                />
              </div>
              <select
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_status: e.target.value });
                }}
                value={filter_status}
              >
                <option value="">เลือกสถานะ</option>
                <option value="เสร็จสิ้น">เสร็จสิ้น</option>
                <option value="ยกเลิก">ยกเลิก</option>
              </select>

              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.setState({
                      filter_search: "",
                      filter_start_date: format_date(new Date(), "yyyy-mm-dd", "en"),
                      filter_end_date: format_date(new Date(), "yyyy-mm-dd", "en"),
                      filter_warehouse_id: "",
                      filter_company_id: "",
                      filter_category_id: "",
                      filter_status: "",
                    });
                    setTimeout(() => {
                      this.Get(1);
                    }, 100);
                  }}
                >
                  ล้างค่า
                </button>
              </div>
              <div className="ms-auto">
                <button className="btn btn-warning px-3 mb-2 me-2" onClick={()=>this.ExportPDF()}>Export PDF</button>
                <DownloadTableExcel
                  filename="รายการรับสินค้า"
                  sheet="รายการรับสินค้า"
                  currentTableRef={this.tableRef.current}
                >
                  <button className="btn btn-warning px-3 mb-2">Excel</button>
                </DownloadTableExcel>
              </div>
            </div>
            <div className="table-responsive" style={{maxHeight:"70vh"}}>
              <table
                className="table rounded-3 overflow-hidden table-hover"
                ref={this.tableRef}
              >
                <tbody>
                  {data_filtered.map((item, index) => (
                    <>
                      <tr>
                        <td className="bg-primary-light text-nowrap">
                          <b>วันที่รับเข้า :</b>{" "}
                          {item.date ? format_date(item.date) : "-"}
                        </td>
                        <td className="bg-primary-light text-nowrap">
                          <b>เลขที่เอกสาร :</b> {item.document_no || "-"}
                        </td>
                        <td className="bg-primary-light text-nowrap" colSpan={2}>
                          <b>คลังสินค้า :</b> {item.warehouse?.name || "-"}
                        </td>
                        <td
                          className="bg-primary-light text-nowrap"
                          colSpan={2}
                        >
                          <b>บริษัทจำหน่าย :</b>{" "}
                          {item.supplier?.company_name || "-"}
                        </td>
                        <td className="bg-primary-light text-nowrap" colSpan={2}>
                          <b>สถานะ :</b> {item.status || "-"}
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-bold text-nowrap">ลำดับ</td>
                        <td className="fw-bold text-nowrap">รหัส/ชื่อสินค้า</td>
                        <td className="fw-bold text-nowrap">Serial No.</td>
                        <td className="fw-bold text-nowrap text-end">จำนวน</td>
                        <td className="fw-bold text-nowrap text-end">
                          ราคา/หน่วย
                        </td>
                        <td className="fw-bold text-nowrap text-end">ส่วนลด</td>
                        <td className="fw-bold text-nowrap text-end">
                          ราคาหักส่วนลด
                        </td>
                        <td className="fw-bold text-nowrap text-end">
                          มูลค่ารวม
                        </td>
                      </tr>
                      {item?.transaction_list?.map((item, index) => (
                        <tr>
                          <td className="text-nowrap">{index + 1}</td>
                          <td className="text-nowrap">
                            {item.product_code} {item.product_name}
                          </td>
                          <td className="text-nowrap">
                            {item.serial_number?.join(", ") || ""}
                          </td>
                          <td className="text-nowrap text-end">{item.qty}</td>
                          <td className="text-nowrap text-end">
                            {item.unit_price}
                          </td>
                          <td className="text-nowrap text-end">
                            {item.discount}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(item.unit_price) - Number(item.discount)
                            )}
                          </td>
                          <td className="text-nowrap text-end">
                            {toFixed(
                              Number(item.qty) *
                                (Number(item.unit_price) -
                                  Number(item.discount))
                            )}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td className="fw-bold bg-light"></td>
                        <td className="fw-bold bg-light"></td>
                        <td className="fw-bold text-center bg-light">รวมเป็นเงิน</td>
                        <td className="fw-bold text-center bg-light">ส่วนลด</td>
                        <td className="fw-bold text-center bg-light">ราคาหักส่วนลด</td>
                        <td className="fw-bold text-center bg-light">Vat 7%</td>
                        <td className="fw-bold text-center bg-light">ค่าส่ง</td>
                        <td className="fw-bold text-center bg-light">รวมทั้งหมด</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td className="fw-bold text-end">{toFixed(item?.amount)}</td>
                        <td className="fw-bold text-end">{toFixed(item?.discount)}</td>
                        <td className="fw-bold text-end">{toFixed(item?.amount - item?.discount)}</td>
                        <td className="fw-bold text-end">{toFixed(item?.vat)}</td>
                        <td className="fw-bold text-end">{toFixed(item?.delivery_cost)}</td>
                        <td className="fw-bold text-end">{toFixed(item?.amount_net)}</td>
                      </tr>
                    </>
                  ))}
                  {data_filtered.length > 0 && (
                    <tr>
                      <td className="fw-bold bg-warning-light text-nowrap" colSpan={2}>
                        ยอดรวมทั้งหมด ({data_filtered.length} รายการ)
                      </td>
                      <td className="fw-bold bg-warning-light text-end">
                        {toFixed(grand_total.amount)}
                      </td>
                      <td className="fw-bold bg-warning-light text-end">
                        {toFixed(grand_total.discount)}
                      </td>
                      <td className="fw-bold bg-warning-light text-end">
                        {toFixed(grand_total.amount_after_discount)}
                      </td>
                      <td className="fw-bold bg-warning-light text-end">
                        {toFixed(grand_total.vat)}
                      </td>
                      <td className="fw-bold bg-warning-light text-end">
                        {toFixed(grand_total.delivery_cost)}
                      </td>
                      <td className="fw-bold bg-warning-light text-end">
                        {toFixed(grand_total.amount_net)}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
